import { render, staticRenderFns } from "./cod-payment-confirm.vue?vue&type=template&id=09eb3ff8&scoped=true"
import script from "./cod-payment-confirm.vue?vue&type=script&lang=js"
export * from "./cod-payment-confirm.vue?vue&type=script&lang=js"
import style0 from "./cod-payment-confirm.vue?vue&type=style&index=0&id=09eb3ff8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09eb3ff8",
  null
  
)

export default component.exports